<div class="add-org-popover">
  <div class="add-org-popover__search">
    <mat-icon class="add-org-popover__search-icon">search</mat-icon>
    <input
      class="add-org-popover__search-input"
      type="text"
      [formControl]="searchControl"
      placeholder="Search parties..."
      autofocus />
    @if (searchControl.value) {
      <button type="button" class="add-org-popover__search-clear" aria-label="Clear search" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <div class="add-org-popover__results">
    @if (loading) {
      <div class="add-org-popover__message"><mat-spinner diameter="16" /><span>Loading...</span></div>
    } @else if (hasError) {
      <div class="add-org-popover__message">Unable to load parties</div>
    } @else if (filteredParties$ | async; as parties) {
      @if (parties.length) {
        <cdk-virtual-scroll-viewport [itemSize]="rowHeight" class="add-org-popover__viewport">
          <button
            type="button"
            *cdkVirtualFor="let party of parties; trackBy: trackById"
            class="add-org-popover__sugg"
            (click)="select(party)">
            <span class="add-org-popover__name" [title]="party.name">{{ party.name }}</span>
            <span class="add-org-popover__number">{{ party.number }}</span>
          </button>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div class="add-org-popover__message">No parties match.</div>
      }
    }
  </div>

  <p class="add-org-popover__footnote">
    You'll assign contacts on the next screen — an organisation is only listed once it has at least one.
  </p>
</div>
